import ai from './modules/ai'
import antifraud from './modules/antifraud'
import comeback from './modules/comeback'
import auth from './auth/modules/auth'
import bannerImage from './modules/bannerImage'
import bots from './modules/bots'
import candidats from './modules/candidats'
import card from './modules/card'
import carReferences from './modules/carReferences'
import chart from './modules/chart'
import chat from './modules/chat'
import newChat from './modules/newChat'
import communications from './modules/communications'
import company from './modules/company'
import dashboard from './modules/dashboard'
import driverReferences from './modules/driverReferences'
import drivers from './modules/drivers'
import employmentContracts from './modules/employmentContracts'
import dumps from './modules/dumps'
import dumpsFinished from './modules/dumpsFinished'
import dumpsInWork from './modules/dumpsInWork'
import dumpsLeaddriver from './modules/dumpsLeaddriver'
import dumpsNew from './modules/dumpsNew'
import dumpsPhotocontrol from './modules/dumpsPhotocontrol'
import dumpsRegistered from './modules/dumpsRegistered'
import dumpsRepeatdriver from './modules/dumpsRepeatdriver'
import financial from './modules/financial'
import ie from './modules/ie'
import ironparks from './modules/ironparks'
import nac from './modules/nac'
import other from './modules/other'
import overdraft from './modules/overdraft'
import operatorMonitoring from './modules/operatorMonitoring'
import payments from './modules/payments'
import payoutStatement from './modules/payoutStatement'
import permission from './modules/permission'
import profile from './modules/profile'
import promotions from './modules/promotions'
import provider from './modules/provider'
import push from './modules/push'
import references from './modules/references'
import referral from './modules/referrals'
import rentauto from './modules/rentauto'
import reports from './modules/reports'
import selfemployment from './modules/selfemployment'
import sms from './modules/sms'
import sos from './modules/sos'
import teams from './modules/teams'
import tel from './modules/tel'
import telephony from './modules/telephony'
import terminals from './modules/terminals'
import transaction from './modules/transaction'
import transactions from './modules/transactions'
import translations from './modules/translations'
import upload from './modules/upload'
import vexport from './modules/export'
import wildberries from './modules/wildberries'
import wolt from './modules/wolt'
export default {
    ai,
    antifraud,
    auth,
    comeback,
    bannerImage,
    bots,
    candidats,
    card,
    carReferences,
    chart,
    chat,
    newChat,
    communications,
    company,
    dashboard,
    driverReferences,
    drivers,
    employmentContracts,
    dumps,
    dumpsFinished,
    dumpsInWork,
    dumpsLeaddriver,
    dumpsNew,
    dumpsPhotocontrol,
    dumpsRegistered,
    dumpsRepeatdriver,
    financial,
    ie,
    ironparks,
    nac,
    other,
    overdraft,
    operatorMonitoring,
    payments,
    payoutStatement,
    permission,
    profile,
    promotions,
    provider,
    push,
    references,
    referral,
    rentauto,
    reports,
    selfemployment,
    sms,
    sos,
    teams,
    tel,
    telephony,
    terminals,
    transaction,
    transactions,
    translations,
    upload,
    vexport,
    wildberries,
    wolt,
}
